import React from "react"
import HomePage from "@components/NewShop/index";
import "@styles/styles.css";
import "@styles/utils.css";

export default function Home() {
  return <HomePage/>
}
